/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StripeBillingPortalConfiguration
 */
export interface StripeBillingPortalConfiguration {
    /**
     * URL to redirect to after the customer closes the billing portal
     * @type {string}
     * @memberof StripeBillingPortalConfiguration
     */
    returnUrl: string;
}

/**
 * Check if a given object implements the StripeBillingPortalConfiguration interface.
 */
export function instanceOfStripeBillingPortalConfiguration(value: object): value is StripeBillingPortalConfiguration {
    if (!('returnUrl' in value) || value['returnUrl'] === undefined) return false;
    return true;
}

export function StripeBillingPortalConfigurationFromJSON(json: any): StripeBillingPortalConfiguration {
    return StripeBillingPortalConfigurationFromJSONTyped(json, false);
}

export function StripeBillingPortalConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): StripeBillingPortalConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'returnUrl': json['returnUrl'],
    };
}

export function StripeBillingPortalConfigurationToJSON(json: any): StripeBillingPortalConfiguration {
    return StripeBillingPortalConfigurationToJSONTyped(json, false);
}

export function StripeBillingPortalConfigurationToJSONTyped(value?: StripeBillingPortalConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'returnUrl': value['returnUrl'],
    };
}

